import React from 'react';
import { Icon } from '@panel/commons';

import { SingleCombo, InputTitle, LocationSelectCombo, IconWrapper, ErrorMessage } from './styles';

export const ComboLocation = ({
  title,
  onChange = () => null,
  value,
  disabled,
  name,
  id,
  register,
  infoRepa,
  placeholder,
  locationData,
  errors,
  validationText,
  onInput
}) => {
  return (
    <SingleCombo>
      <InputTitle data-repa='Step1Modulo2-comboLocation-title'>{title}</InputTitle>
      <LocationSelectCombo
        onInput={onInput}
        onChange={onChange}
        value={value}
        disabled={disabled}
        name={name}
        id={id}
        ref={register}
        data-repa={infoRepa}
      >
        <option data-repa='Step1Modulo2-comboLocation-option' value=''>
          {placeholder}
        </option>
        {locationData &&
          locationData.map(location => (
            <option value={location.location_id} key={location.location_id}>
              {location.name}
            </option>
          ))}
      </LocationSelectCombo>
      <IconWrapper>
        <Icon name='chevronDown' width={16} height={16} viewBox='0 0 16 16' />
      </IconWrapper>
      <ErrorMessage data-repa='Step1Modulo2-comboLocation-error' errors={errors} name={name}>
        {errors && !disabled && validationText}
      </ErrorMessage>
    </SingleCombo>
  );
};
